import React from "react";
import "./LinkButton.css";

const LinkButton = ({ children, onClick }) => {
  return (
    <button className="link-button" onClick={onClick} type="button">
      {children}
    </button>
  );
};

export default LinkButton;
